import moment from 'moment';
import selectFilters from './SelectFilters.js';

const getFullDate = date => {
    return date.length > 1 ? date : `0${date}`;
};

const prepareFrom = (from, fromBc) => {
    if (from && fromBc && from.indexOf('-') < 0) {
        return `-${from}`;
    }

    if (from && !fromBc && from.indexOf('-') >= 0) {
        return `${from.replace('-', '')}`;
    }

    return from;
};

const prepareTo = (to, toBc) => {
    if (to && toBc && to.indexOf('-') < 0) {
        return `-${to}`;
    }

    if (to && !toBc && to.indexOf('-') >= 0) {
        return `${to.replace('-', '')}`;
    }

    return to;
};

const getDateFrom = dateFrom => {
    const dateArrFrom = dateFrom.replace(/_/g, '').split('.');

    const dateYearFrom = dateArrFrom[2];
    const dateMonthFrom = dateArrFrom[1] ? getFullDate(dateArrFrom[1]) : '01';
    const dateDayFrom = dateArrFrom[0] ? getFullDate(dateArrFrom[0]) : '01';

    return `${dateDayFrom}.${dateMonthFrom}.${dateYearFrom}`;
};

const getDateTo = dateTo => {
    const dateArrTo = dateTo.replace(/_/g, '').split('.');

    const dateYearTo = dateArrTo[2];
    const dateMonthTo = dateArrTo[1] ? getFullDate(dateArrTo[1]) : '12';
    const dateDayTo = dateArrTo[0] ? getFullDate(dateArrTo[0]) : moment(`${dateYearTo}-${dateMonthTo}`, "Y-MM-DD").endOf('month').format('DD');

    return `${dateDayTo}.${dateMonthTo}.${dateYearTo}`;
};

const prepareDate = (date) => {
    const from = date.from ? getDateFrom(date.from) : '';
    const to = date.to ? getDateTo(date.to) : '';

    const preparedFrom = prepareFrom(from, date.fromBc);
    const preparedTo = prepareTo(to, date.toBc);

    if (from || to) {
        return {
            id: `${preparedFrom};${preparedTo}`,
            label: `${preparedFrom};${preparedTo}`,
        };
    } else {
        return {
            id: '',
            label: ''
        };
    }
};

const prepareDateYearOnly = (date) => {
    const from = date.from ? date.from.replace(/_/g, '') : '';
    const to = date.to ? date.to.replace(/_/g, '') : '';

    const preparedFrom = prepareFrom(from, date.fromBc);
    const preparedTo = prepareTo(to, date.toBc);

    if (from || to) {
        return {
            id: `${preparedFrom};${preparedTo}`,
            label: `${preparedFrom};${preparedTo}`,
        };
    } else {
        return {
            id: '',
            label: ''
        };
    }
};

export default function(fieldName, state) {
    const currentTab = state.simpleSearchResults.tabs.filter(tab => tab.active)[0];
    const currentFilter = currentTab.allowedFilters.filter(filter => filter.name === fieldName)[0];
    const headingFilters = state.simpleSearchResults.headingFilters;
    const currentFilterHeadingFilters = headingFilters ? headingFilters.filter(filter => filter.name === fieldName)[0] : false;

    if (currentFilterHeadingFilters && currentFilterHeadingFilters.type === "SELECT") {
        return {
            value: [{
                id: state.form.headingFiltersForm.values.headingFiltersSelect,
                label: fieldName,
            }],
            type: currentFilterHeadingFilters.type,
            tab: 'common'
        };
    }
    
    switch (currentFilter.type) {
        case 'TREE_ID':
        case 'ID':
        case 'FACETING_API':
        case 'COMMON_ID':
            return {value: selectFilters(currentFilter.options), tab: currentFilter.common ? 'common' : currentTab.name};
        case 'DATE':
            return {value: [prepareDate(state.form[fieldName].values)], tab: currentFilter.common ? 'common' : currentTab.name};
        case 'DATE_YEAR_ONLY':
            return {value: [prepareDateYearOnly(state.form[fieldName].values)], tab: currentFilter.common ? 'common' : currentTab.name};
        default:
            return [];
    }
};



// WEBPACK FOOTER //
// ./src/scripts/FiltersToApply.js